var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sla-metrics" }, [
    _c("div", { staticClass: "chart-container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-4" }, [
        _c("div", { staticClass: "col-lg-3" }, [
          _c("div", { staticClass: "summary-item" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "summary-content" }, [
              _c("div", { staticClass: "summary-value" }, [
                _vm._v(_vm._s(_vm.slaMetrics.cumplimiento_general || 0) + "%"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "summary-label" }, [
                _vm._v("Cumplimiento General"),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-3" }, [
          _c("div", { staticClass: "summary-item" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "summary-content" }, [
              _c("div", { staticClass: "summary-value" }, [
                _vm._v(_vm._s(_vm.slaMetrics.solicitudes_proximas_vencer || 0)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "summary-label" }, [
                _vm._v("Próximas a Vencer"),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-3" }, [
          _c("div", { staticClass: "summary-item" }, [
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "summary-content" }, [
              _c("div", { staticClass: "summary-value" }, [
                _vm._v(_vm._s(_vm.slaMetrics.solicitudes_vencidas || 0)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "summary-label" }, [_vm._v("Vencidas")]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-3" }, [
          _c("div", { staticClass: "summary-item" }, [
            _vm._m(4),
            _vm._v(" "),
            _c("div", { staticClass: "summary-content" }, [
              _c("div", { staticClass: "summary-value" }, [
                _vm._v(
                  _vm._s(_vm.slaMetrics.tiempo_resolucion_promedio || 0) + "h"
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "summary-label" }, [
                _vm._v("Tiempo Promedio"),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-4" }, [
        _c("div", { staticClass: "col-lg-4" }, [
          _c("div", { staticClass: "summary-item" }, [
            _vm._m(5),
            _vm._v(" "),
            _c("div", { staticClass: "summary-content" }, [
              _c("div", { staticClass: "summary-value" }, [
                _vm._v(_vm._s(_vm.slaMetrics.cumplimiento_alta || 0) + "%"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "summary-label" }, [
                _vm._v("Alta Prioridad"),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-4" }, [
          _c("div", { staticClass: "summary-item" }, [
            _vm._m(6),
            _vm._v(" "),
            _c("div", { staticClass: "summary-content" }, [
              _c("div", { staticClass: "summary-value" }, [
                _vm._v(_vm._s(_vm.slaMetrics.cumplimiento_media || 0) + "%"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "summary-label" }, [
                _vm._v("Media Prioridad"),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-4" }, [
          _c("div", { staticClass: "summary-item" }, [
            _vm._m(7),
            _vm._v(" "),
            _c("div", { staticClass: "summary-content" }, [
              _c("div", { staticClass: "summary-value" }, [
                _vm._v(_vm._s(_vm.slaMetrics.cumplimiento_baja || 0) + "%"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "summary-label" }, [
                _vm._v("Baja Prioridad"),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-4" }, [
        _c("div", { staticClass: "col-lg-4" }, [
          _c("div", { staticClass: "summary-item" }, [
            _vm._m(8),
            _vm._v(" "),
            _c("div", { staticClass: "summary-content" }, [
              _c("div", { staticClass: "summary-value" }, [
                _vm._v(
                  _vm._s(_vm.slaMetrics.tiempo_resolucion_promedio || 0) + "h"
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "summary-label" }, [
                _vm._v("Tiempo de Resolución"),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-4" }, [
          _c("div", { staticClass: "summary-item" }, [
            _vm._m(9),
            _vm._v(" "),
            _c("div", { staticClass: "summary-content" }, [
              _c("div", { staticClass: "summary-value" }, [
                _vm._v(
                  _vm._s(_vm.slaMetrics.tiempo_asignacion_promedio || 0) + "h"
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "summary-label" }, [
                _vm._v("Tiempo de Asignación"),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-4" }, [
          _c("div", { staticClass: "summary-item" }, [
            _vm._m(10),
            _vm._v(" "),
            _c("div", { staticClass: "summary-content" }, [
              _c("div", { staticClass: "summary-value" }, [
                _vm._v(
                  _vm._s(_vm.slaMetrics.tiempo_escalacion_promedio || 0) + "h"
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "summary-label" }, [
                _vm._v("Tiempo de Escalamiento"),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", [
      _c("i", { staticClass: "fal fa-clock text-info" }),
      _vm._v(" Métricas de Cumplimiento SLA"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "summary-icon text-success" }, [
      _c("i", { staticClass: "fal fa-check-circle fa-2x" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "summary-icon text-warning" }, [
      _c("i", { staticClass: "fal fa-exclamation-triangle fa-2x" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "summary-icon text-danger" }, [
      _c("i", { staticClass: "fal fa-times-circle fa-2x" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "summary-icon text-info" }, [
      _c("i", { staticClass: "fal fa-clock fa-2x" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "summary-icon text-danger" }, [
      _c("i", { staticClass: "fal fa-flag fa-2x" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "summary-icon text-warning" }, [
      _c("i", { staticClass: "fal fa-flag fa-2x" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "summary-icon text-success" }, [
      _c("i", { staticClass: "fal fa-flag fa-2x" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "summary-icon text-primary" }, [
      _c("i", { staticClass: "fal fa-stopwatch fa-2x" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "summary-icon text-info" }, [
      _c("i", { staticClass: "fal fa-user-clock fa-2x" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "summary-icon text-warning" }, [
      _c("i", { staticClass: "fal fa-level-up-alt fa-2x" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }